import * as React from "react";
import {
  IPeerGroupsProps,
  IFilter,
  getPeerGroupData,
  IVisualizationState,
  IPeerGroupTabsProps,
} from "../../lib/http";
import * as ReactHighcharts from "react-highcharts";
import { Panel, Row, Col } from "react-bootstrap";

interface IPiePiece {
  name: string;
  y: number;
  color?: string;
}

interface ISeries {
  name: string;
  innerSize?: string;
  data: IPiePiece[];
}

interface IAssetAllocationByStrategyState {
  title: string;
  loading: boolean;
  visualizationEightTitle: string;
  visualizationEightThresholdOne: string;
  visualizationEightThresholdTwo: string;
  visualizationNineTitle: string;
  visualizationNineThresholdOne: string;
  visualizationNineThresholdTwo: string;
  visualizationTenTitle: string;
  visualizationTenThresholdOne: string;
  visualizationTenThresholdTwo: string;
  visualizationElevenTitle: string;
  visualizationElevenThresholdOne: string;
  visualizationElevenThresholdTwo: string;
  visualizationEightData: IPiePiece[];
  visualizationNineData: IPiePiece[];
  visualizationTenData: IPiePiece[];
  visualizationElevenData: IPiePiece[];
  data: any[];
  filters: IFilter;
  currentPeerGroup: any;
}

export class AssetAllocationByStrategy extends React.Component<
  IPeerGroupTabsProps,
  IAssetAllocationByStrategyState
> {
  state: IAssetAllocationByStrategyState = {
    title: "",
    loading: false,
    data: [],
    filters: { assetLevel: 0 },
    visualizationEightTitle: "",
    visualizationEightThresholdOne: "",
    visualizationEightThresholdTwo: "",
    visualizationNineTitle: "",
    visualizationNineThresholdOne: "",
    visualizationNineThresholdTwo: "",
    visualizationTenTitle: "",
    visualizationTenThresholdOne: "",
    visualizationTenThresholdTwo: "",
    visualizationElevenTitle: "",
    visualizationElevenThresholdOne: "",
    visualizationElevenThresholdTwo: "",
    visualizationEightData: [],
    visualizationNineData: [],
    visualizationTenData: [],
    visualizationElevenData: [],
    currentPeerGroup: {},
  };

  componentDidMount() {
    this.setState({ data: this.props.data }, () =>
      this.loadSeries(this.props.filters)
    );
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.filters.assetLevel !== this.props.filters.assetLevel ||
      prevProps.data.length !== this.props.data.length
    ) {
      this.setState(
        { filters: this.props.filters, data: this.props.data },
        () => {
          this.loadSeries(this.props.filters);
        }
      );
    }
  }

  loadSeries(filters: IFilter) {
    const { data } = this.state;

    if (!data || data.length == 0) {
      return;
    }

    const currentSet = data.find(
      (dataPoint) => dataPoint.filterId === filters.assetLevel
    );

    this.setState({
      visualizationEightTitle: currentSet.Strat_T_V8_Vis8Title,
      visualizationEightThresholdOne: currentSet.Strat_T_V8_PresThreshold1,
      visualizationEightThresholdTwo: currentSet.Strat_T_V8_PresThreshold2,
      visualizationNineTitle: currentSet.Strat_T_V9_Vis9Title,
      visualizationNineThresholdOne: currentSet.Strat_T_V9_BalThreshold1,
      visualizationNineThresholdTwo: currentSet.Strat_T_V9_BalThreshold2,
      visualizationTenTitle: currentSet.Strat_T_V10_Vis10Title,
      visualizationTenThresholdOne: currentSet.Strat_T_V10_AppThreshold1,
      visualizationTenThresholdTwo: currentSet.Strat_T_V10_AppThreshold2,
      visualizationElevenTitle: currentSet.Strat_T_V11_Vis11Title,
      visualizationElevenThresholdOne: currentSet.Strat_T_V11_InvOthThreshold1,
      visualizationElevenThresholdTwo: currentSet.Strat_T_V11_InvOthThreshold2,
      visualizationEightData: [
        {
          name: currentSet.Strat_T_V8_PresLabel1,
          color: "#D9D9D9",
          y: currentSet.Strat_N_V8_PresCashFixed,
        },
        {
          name: currentSet.Strat_T_V8_PresLabel2,
          color: "#C6E0B4",
          y: currentSet.Strat_N_V8_PresEqInv,
        },
      ],
      visualizationNineData: [
        {
          name: currentSet.Strat_T_V9_BalLabel1,
          color: "#D9D9D9",
          y: currentSet.Strat_N_V9_BalCashFixed,
        },
        {
          name: currentSet.Strat_T_V9_BalLabel2,
          color: "#C6E0B4",
          y: currentSet.Strat_N_V9_BalMix,
        },
      ],
      visualizationTenData: [
        {
          name: currentSet.Strat_T_V10_AppLabel1,
          color: "#D9D9D9",
          y: currentSet.Strat_N_V10_AppCashFixed,
        },
        {
          name: currentSet.Strat_T_V10_AppLabel2,
          color: "#C6E0B4",
          y: currentSet.Strat_N_V10_AppEq,
        },
      ],
      visualizationElevenData: [
        {
          name: currentSet.Strat_T_V11_InvOthLabel2,
          color: "#D9D9D9",
          y: currentSet.Strat_N_V11_InvOthCashFxdEq,
        },
        {
          name: currentSet.Strat_T_V11_InvOthLabel1,
          color: "#D9E1F2",
          y: currentSet.Strat_N_V11_InvOthInvOth,
        },
      ],
      loading: false,
      currentPeerGroup: currentSet,
    });
  }

  renderPiePanel(title, thresholdOne, thresholdTwo, data, labelOne, labelTwo) {
    const series = [{ name: title, data: data }];
    return (
      <Panel>
        <div
          className="panel-heading text-center"
          style={{ minHeight: "200px" }}
        >
          <h5>{title}</h5>
          <small>{thresholdOne}</small>
        </div>
        <div className="panel-body">
          <ReactHighcharts
            config={AssetAllocationByStrategy.getPublicIndexConfig(
              series,
              title
            )}
          ></ReactHighcharts>
        </div>
      </Panel>
    );
  }

  static getPublicIndexConfig(series: ISeries[], title) {
    return {
      chart: { type: "pie", height: 300 },
      title: {
        text: title,
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          size: "100%",
          dataLabels: {
            enabled: true,
            distance: -50,
            crop: false,
          },
          showInLegend: true,
        },
      },
      tooltip: { enabled: false },
      legend: { enabled: false },
      credits: { enabled: false },
      series,
    };
  }

  render() {
    const {
      visualizationEightTitle,
      visualizationEightThresholdOne,
      visualizationEightThresholdTwo,
      visualizationNineTitle,
      visualizationNineThresholdOne,
      visualizationNineThresholdTwo,
      visualizationTenTitle,
      visualizationTenThresholdOne,
      visualizationTenThresholdTwo,
      visualizationElevenTitle,
      visualizationElevenThresholdOne,
      visualizationElevenThresholdTwo,
      visualizationEightData,
      visualizationElevenData,
      visualizationNineData,
      visualizationTenData,
      currentPeerGroup,
    } = this.state;
    return (
      <Panel>
        <div className="panel-body">
          <Row>
            <Col sm={12} md={3}>
              {this.renderPiePanel(
                visualizationEightTitle,
                visualizationEightThresholdOne,
                visualizationEightThresholdTwo,
                visualizationEightData,
                currentPeerGroup.Strat_T_V8_PresLabel1,
                currentPeerGroup.Strat_T_V8_PresLabel2
              )}
            </Col>
            <Col sm={12} md={3}>
              {this.renderPiePanel(
                visualizationNineTitle,
                visualizationNineThresholdOne,
                visualizationNineThresholdTwo,
                visualizationNineData,
                currentPeerGroup.Strat_T_V9_BalLabel1,
                currentPeerGroup.Strat_T_V9_BalLabel2
              )}
            </Col>
            <Col sm={12} md={3}>
              {this.renderPiePanel(
                visualizationTenTitle,
                visualizationTenThresholdOne,
                visualizationTenThresholdTwo,
                visualizationTenData,
                currentPeerGroup.Strat_T_V10_AppLabel1,
                currentPeerGroup.Strat_T_V10_AppLabel2
              )}
            </Col>
            <Col sm={12} md={3}>
              {this.renderPiePanel(
                visualizationElevenTitle,
                visualizationElevenThresholdOne,
                visualizationElevenThresholdTwo,
                visualizationElevenData,
                currentPeerGroup.Strat_T_V11_InvOthLabel1,
                currentPeerGroup.Strat_T_V11_InvOthLabel2
              )}
            </Col>
          </Row>
        </div>
      </Panel>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/visualizations/PeerGroups/AssetAllocation/AssetAllocationByStrategy/index.tsx